/* eslint-disable @typescript-eslint/ban-ts-comment */
import { ClipLoader } from "react-spinners";
import { useTheme } from "../../../context/ThemeProvider";
import SearchNotFoundAnimation from "../../../components/SearchNotFoundAnimation";
import { useNotificationList } from "../../../store/api/useNotificationList";
import { IoNotifications } from "react-icons/io5";
import chatSidebarTime from "../../../utils/chatSidebarTime";
import { useTimeFormatOptions } from "../../../hooks/useTimeFormatOptions";
import TextTranslate from "../../../utils/TextTranslate";

const groupClass =
  "overflow-hidden rounded-2xl bg-secondary shadow-sm ring-1 ring-black/[0.04] dark:ring-white/[0.06]";
const divide =
  "[&>*+*]:border-t [&>*+*]:border-black/[0.06] dark:[&>*+*]:border-white/[0.08]";

export default function NotificationList() {
  const { translate, hour12 } = useTimeFormatOptions();
  // @ts-ignore
  const { theme } = useTheme();
  const { data, isLoading } = useNotificationList();

  const records = data?.data?.Records ?? [];

  return (
    <div className="flex h-full min-h-0 w-full flex-col overflow-y-auto px-4 py-4 pb-8">
      {isLoading ? (
        <div className="grid flex-1 place-content-center">
          <ClipLoader size={23} color={theme == "dark" ? "white" : "black"} />
        </div>
      ) : records.length === 0 ? (
        <div className="grid flex-1 place-content-center gap-4 text-center text-lightText">
          <SearchNotFoundAnimation />
          <div>
            <TextTranslate text="No Notifications" />
          </div>
        </div>
      ) : (
        <div className={`${groupClass} ${divide}`}>
          {records.map((e) => (
            <div
              key={e.notification_id}
              className="flex items-start gap-3 px-3 py-3.5"
            >
              <div className="mt-0.5 grid h-10 w-10 shrink-0 place-content-center rounded-full bg-themeColor text-themeTextColor">
                <IoNotifications className="text-lg" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0 text-[15px] font-semibold text-darkText">
                    {e?.title}
                  </div>
                  <div className="shrink-0 text-[12px] text-lightText">
                    {chatSidebarTime(e?.createdAt, { translate, hour12 })}
                  </div>
                </div>
                <div className="mt-0.5 text-[14px] leading-snug text-lightText">
                  {e?.message}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
